<template>
  <b-card>
    <!-- ค้นเจ้าของโดเมน — คนที่มาร้องเรียนรู้แค่ชื่อโดเมน ไม่รู้ว่าใครถืออยู่ · อยู่บนหน้านี้เพราะ
         หน้านี้ค้นด้วยชื่อโดเมนอยู่แล้วและเป็นหน้าของ Master · การย้ายโดเมนก็เป็นของ Master
         คนเดียวทุกกรณี ไม่ว่าในสายเดียวกันหรือข้ามสาย -->
    <div class="d-flex align-items-center mb-2">
      <feather-icon
        icon="SearchIcon"
        size="18"
        class="mr-50 text-primary"
      />
      <h5 class="mb-0">
        {{ $t('agentDomain.lookup.title') }}
      </h5>
    </div>

    <b-row class="mb-1">
      <b-col
        cols="12"
        md="4"
        class="mb-1 mb-md-0"
      >
        <b-form-input
          v-model="lookupDomain"
          :placeholder="$t('agentDomain.placeholders.domain')"
          @keydown.enter="lookupOwner"
        />
      </b-col>
      <b-col
        cols="12"
        md="8"
      >
        <b-button
          variant="primary"
          :disabled="lookupBusy"
          @click="lookupOwner"
        >
          {{ $t('agentDomain.lookup.search') }}
        </b-button>
      </b-col>
    </b-row>

    <b-alert
      v-if="lookupDone && lookupResult === null"
      show
      variant="secondary"
      class="px-1 py-1"
    >
      {{ $t('agentDomain.lookup.notFound') }}
    </b-alert>

    <b-row
      v-if="lookupResult"
      class="mb-2 align-items-center"
    >
      <b-col
        cols="12"
        md="4"
        class="mb-1 mb-md-0"
      >
        <div class="font-weight-bolder">
          {{ lookupResult.domain }}
        </div>
        <small class="text-muted">
          {{ $t('agentDomain.lookup.owner') }} {{ lookupResult.agent }}
        </small>
      </b-col>
      <b-col
        cols="12"
        md="4"
        class="mb-1 mb-md-0"
      >
        <b-form-input
          v-model="moveTarget"
          :placeholder="$t('agentDomain.lookup.movePlaceholder')"
          @keydown.enter="moveDomain"
        />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-button
          variant="outline-warning"
          :disabled="moveBusy || !canMove"
          @click="moveDomain"
        >
          {{ $t('agentDomain.lookup.move') }}
        </b-button>
      </b-col>
    </b-row>

    <hr class="mb-2">

    <div class="d-flex align-items-center mb-2">
      <feather-icon
        icon="ClockIcon"
        size="18"
        class="mr-50 text-primary"
      />
      <h5 class="mb-0">
        {{ $t('agentDomain.history.title') }}
      </h5>
    </div>

    <b-row class="mb-1">
      <b-col
        cols="12"
        md="4"
        class="mb-1 mb-md-0"
      >
        <b-form-input
          v-model="filterDomain"
          :placeholder="$t('agentDomain.history.filterDomain')"
          @keydown.enter="search"
        />
      </b-col>
      <b-col
        cols="12"
        md="4"
        class="mb-1 mb-md-0"
      >
        <b-form-input
          v-model="filterAgent"
          :placeholder="$t('agentDomain.history.filterAgent')"
          @keydown.enter="search"
        />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-button
          variant="primary"
          @click="search"
        >
          {{ $t('agentDomain.history.search') }}
        </b-button>
      </b-col>
    </b-row>

    <b-table
      striped
      hover
      responsive
      small
      :items="items"
      :fields="tableFields"
      :busy="loading"
      show-empty
      :empty-text="$t('agentDomain.history.empty')"
    >
      <template #cell(action)="data">
        <b-badge :variant="actionVariant(data.item.action)">
          {{ $t(`agentDomain.history.actions.${data.item.action}`) }}
        </b-badge>
      </template>

      <template #cell(domain)="data">
        <div class="font-weight-bolder">
          {{ data.item.domain }}
        </div>
        <small
          v-if="data.item.previousDomain"
          class="text-muted"
        >
          {{ data.item.previousDomain }} →
        </small>
      </template>

      <template #cell(move)="data">
        <span>{{ data.item.fromAgent || '—' }} → {{ data.item.toAgent || '—' }}</span>
      </template>
    </b-table>

    <b-pagination
      v-model="currentPage"
      :total-rows="total"
      :per-page="perPage"
      align="center"
      size="sm"
      class="my-0"
      @change="onPageChange"
    />
  </b-card>
</template>

<script>
import {
  BAlert, BBadge, BButton, BCard, BCol, BFormInput, BPagination, BRow, BTable,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import agentService from '@/service/agentService'

export default {
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCol,
    BFormInput,
    BPagination,
    BRow,
    BTable,
  },
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      perPage: 50,
      currentPage: 1,
      filterDomain: '',
      filterAgent: '',
      lookupDomain: '',
      lookupBusy: false,
      lookupDone: false,
      lookupResult: null,
      moveTarget: '',
      moveBusy: false,
    }
  },
  computed: {
    // ปลายทางเป็นเจ้าของอยู่แล้วไม่ใช่การย้าย — ปล่อยให้กดได้จะได้ข้อความยืนยันว่า "ไม่กระทบใคร"
    // แล้วเขียนประวัติการย้ายที่ไม่ได้เกิดขึ้นจริงลงไป
    canMove() {
      return !!this.moveTarget
        && !!this.lookupResult
        && this.moveTarget !== this.lookupResult.agent
    },
    tableFields() {
      return [
        { key: 'createAt', label: this.$t('agentDomain.history.at'), class: 'text-nowrap' },
        { key: 'action', label: this.$t('agentDomain.history.action') },
        { key: 'domain', label: this.$t('agentDomain.history.domain') },
        { key: 'move', label: this.$t('agentDomain.history.move'), class: 'text-nowrap' },
        { key: 'actorUsername', label: this.$t('agentDomain.history.actor'), class: 'text-nowrap' },
        { key: 'actorAgent', label: this.$t('agentDomain.history.actorAgent'), class: 'text-nowrap' },
      ]
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    /**
     * คำถามล้มเหลวกับ "ไม่มีใครถือ" ต้องแยกกันเด็ดขาด — คำตอบนี้คือสิ่งที่ใช้ตัดสินว่าโดเมนว่างหรือไม่
     * ถ้าเอา 403 หรือ 500 ไปแสดงว่า "ยังไม่มีใครลงทะเบียน" คนดูจะสรุปว่าโดเมนว่างทั้งที่มีเจ้าของอยู่
     */
    async lookupOwner() {
      if (this.lookupBusy || !this.lookupDomain) return
      this.lookupBusy = true
      try {
        const res = await agentService.getAuthen(`agent-domain/owner?domain=${encodeURIComponent(this.lookupDomain)}`)
        if (res.status !== 200) {
          this.notify('danger', this.errorText(res.data))
          return
        }

        this.lookupResult = res.data.found === true ? res.data : null
        this.moveTarget = ''
        this.lookupDone = true
      } finally {
        this.lookupBusy = false
      }
    },
    /**
     * ย้ายเป็นรายการเดียว ไม่ใช่ถอนแล้วเพิ่มใหม่ — ประวัติต้องอ่านออกว่าเป็นการย้าย และระหว่าง
     * สองขั้นตอนโดเมนจะว่างจนมีคนจดตัดหน้าได้
     *
     * ต้องเห็นผลกระทบต่อการล็อกอินก่อนยืนยันเสมอ เพราะขอบเขตของการล็อกอินด้วยชื่อผู้ใช้เปล่า
     * ผูกอยู่กับสายของเจ้าของโดเมน การเปลี่ยนมือจึงเปลี่ยนขอบเขตนั้นไปด้วย
     */
    async moveDomain() {
      if (this.moveBusy || !this.lookupResult || !this.canMove) return
      this.moveBusy = true
      try {
        const impactRes = await agentService.getAuthen(
          `agent-domain/${this.lookupResult.id}/move-impact?agent=${encodeURIComponent(this.moveTarget)}`,
        )
        if (impactRes.status !== 200) {
          this.notify('danger', this.errorText(impactRes.data))
          return
        }

        const confirmed = await this.$swal({
          dark: true,
          title: this.$t('agentDomain.lookup.confirmMoveTitle'),
          text: this.$t(`agentDomain.lookup.impact.${impactRes.data.impact}`, {
            domain: impactRes.data.domain,
            from: impactRes.data.fromAgent,
            to: impactRes.data.toAgent,
          }),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('agentDomain.lookup.move'),
          cancelButtonText: this.$t('agentDomain.actions.cancel'),
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-outline-secondary ml-1',
          },
          buttonsStyling: false,
        })
        if (confirmed.value !== true) return

        const res = await agentService.putAuthen(`agent-domain/${this.lookupResult.id}`, {
          agent: this.moveTarget,
          domain: this.lookupResult.domain,
        })
        if (res.status !== 200) {
          this.notify('danger', this.errorText(res.data))
          return
        }

        this.notify('success', this.$t('agentDomain.lookup.moved'))
        await Promise.all([this.lookupOwner(), this.load()])
      } finally {
        this.moveBusy = false
      }
    },
    errorText(data) {
      if (typeof data === 'string') return data
      if (data && data.message) return data.message
      return this.$t('accountMembers.messages.fallbackError')
    },
    notify(variant, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: variant === 'success'
            ? this.$t('accountMembers.messages.success')
            : this.$t('accountMembers.messages.error'),
          icon: variant === 'success' ? 'CoffeeIcon' : 'AlertCircleIcon',
          variant,
          text,
        },
      })
    },
    actionVariant(action) {
      if (action === 'Added') return 'light-success'
      if (action === 'Removed') return 'light-danger'
      return 'light-warning'
    },
    search() {
      this.currentPage = 1
      this.load()
    },
    onPageChange(page) {
      this.currentPage = page
      this.$nextTick(this.load)
    },
    async load() {
      this.loading = true
      try {
        const params = new URLSearchParams({
          page: this.currentPage,
          limit: this.perPage,
        })
        if (this.filterDomain) params.append('domain', this.filterDomain)
        if (this.filterAgent) params.append('agent', this.filterAgent)

        const res = await agentService.getAuthen(`agent-domain/history?${params.toString()}`)
        if (res.status === 200) {
          this.items = (res.data.items || []).map(v => ({
            ...v,
            createAt: v.createAt ? new Date(v.createAt).toLocaleString() : '-',
          }))
          this.total = res.data.total || 0
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
